import React,{Component} from 'react'
import axios from 'axios'
import querystring from 'querystring'
import clone from 'clone'
import Modal from 'react-bootstrap-modal'
import ImageZoom from 'react-medium-image-zoom'

import * as config from "../../../config"
import Spinner from '../../Shared/Spinner'

import moment from 'moment';
import "moment/locale/ru";

let timeout;
let timeout2;

class Product extends Component{
    constructor(props){
        super(props)
        this.state ={
            companyId:this.props.companyId,
            modalDetailsIsOpen:false,
            fetching:false,
            data:[],
            searchText:"",
            barcode:"",
            page:1,
            size:25,
            total:0,
            offerId:this.props.data.offerId
        }
    }
    handleItemClick(){
        this.setState({
            modalDetailsIsOpen:true
        })
    }
    closeModal() {
        this.setState({            
            modalDetailsIsOpen: false            
        });
    }
    render(){
        let {data} = this.props;
        
        let classNameModal = "big-modal modal-bindings";
        if(this.state.fetching){
            classNameModal += " fetching";
        }

        return(
            <React.Fragment>
                <tr onClick={()=>this.handleItemClick()} className="cursor-pointer">
                                                <td>{data.offerId}</td>
                                                <td>{data.name}</td>
                                                <td>{data.price}</td>
                                                <td>{data.availability}</td>
                                                <td>
                                                    <a href={data.url} target="_blank" title="открыть в новом окне">{data.url}</a>
                                                </td>
                                                <td>
                                                    {
                                                        data.isActive?
                                                            <span className="label label-success label-xs">активный</span>
                                                            :
                                                            <span className="label label-default">не активный</span>
                                                    }
                                                </td>
                                                <td>{moment(data.createDate).format('DD.MM.YYYY hh:mm')}</td>                                               
                                                <td>{moment(data.updateDate).format('DD.MM.YYYY hh:mm')}</td>                                                
                                            </tr>
                                            <Modal
                                            bssize={"large"}
                                            show={this.state.modalDetailsIsOpen}
                                            onHide={()=> this.closeModal()}
                                            aria-labelledby="contained-modal-title-lg"
                                            className={classNameModal}
                                        >
                                            <Modal.Header closeButton>
                                                <Modal.Title id='ModalHeader'>Детали</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="modal-details"><pre lang="xml" >{data.offerDetails}</pre></div>
                                            </Modal.Body>
                                        </Modal> 
            </React.Fragment>
        );
    }
}

export default Product;


// WEBPACK FOOTER //
// ./src/components/Dashboard/Errors/Product.jsx